<div class="user-card">

  <div 
  fxLayout="row" 
  fxLayoutAlign="center" 
  class="widget-header" 
  matTooltip="{{assignment.LessonName}}"
  [ngStyle]="{'background-color': colorCode}"
  (click)="onAssignmentClick()" 
  id="{{assignment.AttemptID == -1 ? 'noid' : 0}}">
    {{ assignment.LessonName }}
  </div>

  <div class="widget-body text-center">
      <div fxLayout="row" class="text-box btm-border">
        <div class="left">
            Grade &nbsp;
            <span class="grade">{{ assignment.Grade || '-'}}</span>
        </div>
        <div class="icon-wrapper right" 
          *ngIf="assignment.AttemptID != -1">
          <mat-icon class="material-icons-outlined edit-grade" 
          (click)="onGradeClick()"
          >
            create 
          </mat-icon>
        </div>
      </div>

      <div fxLayout="row" class="text-box btm-border">
        <div class="left">
          Release Grade
        </div>
        <div class="right">
          <mat-slide-toggle   [checked]="assignment.GradeReleased"
                              (change)="releaseGradeChanged($event)"
                              [disabled]="!assignment.Grade">
          </mat-slide-toggle>
        </div>
      </div>

      <div fxLayout="column" fxLayoutAlign="space-around center" class="submitdate-text-box btm-border">
          <span>Submit Date: </span>
          <span>
            {{assignment.SubmitDate ? assignment.SubmitDate : '-'}}</span>
      </div>

     

      <div class="text-box btm-border" fxLayout="row" fxLayoutAlign="space-around center">
        <button class="view-work-text failure"
          target="_blank"
          (click)="openUnassignDialog()"
          [disabled]="assignment.AttemptID != -1"
        >
          Unassign
        </button>

        <button class="view-work-text failure"
          target="_blank"
          (click)="openReassignDialog()"
          [disabled]="assignment.AttemptID == -1"
        >
          Reassign
        </button>
      </div>

      <div class="text-box" fxLayout="row" fxLayoutAlign="space-around center">
        <a 
          target="_blank"

          [routerLink]="['/ELearning/ViewWork']"
                  [queryParams]="{
                    AttemptID: assignment.AttemptID,
                    AssignmentID: assignment.AssignmentID,
                    AssignmentName: assignment.LessonName,
                    StudentName: studentName
                  }"
          [class.disabled]="assignment.AttemptID == -1"
        >
        <button
        class="view-work-text"
        [disabled]="assignment.AttemptID == -1">


          View Work
        </button>
        </a>
      </div>
  </div>

</div>
